import { ArrowDownRight } from "lucide-react";

export default function Hero() {
  const scrollToOrder = () =>
    document.getElementById("pedido")?.scrollIntoView({ behavior: "smooth" });
  const scrollToFlavors = () =>
    document.getElementById("sabores")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="top" data-testid="hero-section" className="relative">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 pt-14 md:pt-24 pb-16 md:pb-28">
        <div className="flex items-center gap-4 text-xs md:text-sm tracking-[0.2em] uppercase animate-fade-up">
          <span className="inline-block w-10 h-px bg-black" />
          <span>Sem açúcar · Sem glúten · Sem lactose · Com colágeno hidrolisado</span>
        </div>

        <h1
          data-testid="hero-title"
          className="font-display mt-8 md:mt-10 text-[44px] leading-[0.95] sm:text-6xl md:text-[96px] lg:text-[132px] tracking-[-0.03em] animate-fade-up"
        >
          DOÇURA
          <br />
          QUE TE <span className="italic">MOVE.</span>
        </h1>

        <div className="mt-10 md:mt-14 grid md:grid-cols-12 gap-8 md:gap-12 items-end">
          <p
            data-testid="hero-subtitle"
            className="md:col-span-6 text-base md:text-lg leading-relaxed max-w-xl animate-fade-up"
          >
            Você treina. Você entrega. Você não se rende. Agora existe um brownie à altura
            do seu ritmo — denso, úmido, 100% sem açúcar, sem glúten e sem lactose.
            <br />
            <span className="font-medium">Prazer real. Zero culpa. Zero concessão.</span>
          </p>

          <div className="md:col-span-6 flex flex-col sm:flex-row items-start sm:items-center gap-4 md:justify-end animate-fade-up">
            <button data-testid="hero-cta-order" onClick={scrollToOrder} className="btn-primary">
              Peça agora
              <ArrowDownRight size={16} strokeWidth={2} />
            </button>
            <button data-testid="hero-cta-flavors" onClick={scrollToFlavors} className="btn-outline">
              Ver sabores
            </button>
          </div>
        </div>

        <div className="hairline mt-16 md:mt-24" />

        <div className="grid grid-cols-2 md:grid-cols-5 mt-8 md:mt-10 gap-y-8">
          <Stat k="00" label="Açúcar" />
          <Stat k="00" label="Glúten" />
          <Stat k="00" label="Lactose" />
          <Stat k="05" label="Sabores" />
          <Stat k="+" label="Colágeno hidrolisado" />
        </div>
      </div>
    </section>
  );
}

function Stat({ k, label }) {
  return (
    <div data-testid={`hero-stat-${label.toLowerCase()}`} className="flex flex-col">
      <span className="font-display text-4xl md:text-6xl leading-none">{k}</span>
      <span className="mt-2 text-xs md:text-sm uppercase tracking-[0.2em]">{label}</span>
    </div>
  );
}
